import React, {useEffect} from "react";
import {Container} from "react-bootstrap";
import {regularTextStyles} from "../Style";
import FooterTFAF from "./FooterTFAF";

const ConvertedTFAF = props => {
    const handleNewQuoteClick = () => {
        window.location.href = '/vehicle';
    };
  useEffect(() => {
  }, []);

  return (
        <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
            <Container fluid style={{flex: 1}}>
                <Container>
                    <br/>
                    <br/>

                    <p style={regularTextStyles}>This link is no longer valid, as the quote has already been
                        converted. </p>

                  <p style={regularTextStyles}> If you’re wanting to buy another car insurance
                        policy,
                        please get <span style={{
                            color: '#1851A3', textDecoration: "underline",
                            cursor: "pointer",
                        }}
                                         onClick={handleNewQuoteClick}>
                      new quote
                </span>.

                    </p>
                    <br/><br/><br/><br/>
                </Container>
            </Container>
            <FooterTFAF/>
        </div>
    );
}

export default ConvertedTFAF;
